import React from 'react';
const SkWave = (props) => {
  return (
    <div style={props.style}>
      <div className="sk-wave">
        <div className="sk-rect sk-rect1"></div>&nbsp;
        <div className="sk-rect sk-rect2"></div>&nbsp;
        <div className="sk-rect sk-rect3"></div>&nbsp;
        <div className="sk-rect sk-rect4"></div>&nbsp;
        <div className="sk-rect sk-rect5"></div>
      </div>
    </div>
  );
};

export default SkWave;


// WEBPACK FOOTER //
// ./src/components/SkWave/SkWave.js